import { render, staticRenderFns } from "./MerchandisingMaterial.vue?vue&type=template&id=e50ca016&"
import script from "./MerchandisingMaterial.vue?vue&type=script&lang=js&"
export * from "./MerchandisingMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports